import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import './../src/assets/css/custom.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Transaction } from './pages/transaction';
import { Invoice } from './pages/invoice'
import { Packing_Inspections } from './pages/Packing - Inspections';
import { Delivery } from './pages/delivery';
import { Stock_Reconciliation } from './pages/stock_reconciliation';
import { Payment_Reconciliation } from './pages/payment_reconciliation';
import { Retail } from './pages/retail';
import APPSTORE_ICON from './assets/images/app-appstore.png';
import PLAYSTORE_ICON from './assets/images/app-playstore.png';
import { TransactionPacking } from './pages/transaction_packing';
import { TransactionDelivery } from './pages/transaction_delivery';
import { TransactionStock } from './pages/transaction_stock';
import { DeleteAccount } from './pages/delete-account';
import OrderFormListPage from './pages/order-form';
import SuccessOrder from './pages/success_order';
import { PurchaseOrder } from './pages/purchase-order'; 
import { RetailInfo } from './pages/retail-info';
import { CustomerChatPage } from './pages/customer-chat';
import { RetailView } from './pages/retaile-view';
import { ConfirmationMessage } from './pages/confirmation-message';
import { PurchaseOrderView } from './pages/purchase-order-view';
import { OrderHistory } from './components/order-history';

function App() {
  const currentYear = new Date()?.getFullYear();
  const [location, setLocation] = useState('');
  useEffect(() => {
    const location = window.location.pathname;
    setLocation(location);
  }, []);
  return (
    <div className='d-flex flex-column vh-100'>
      <BrowserRouter>

        <Routes>
          {/* <Route path='/' element={< LoginOtp />}></Route> */}
          <Route path='/purchase-order/:id' element={<PurchaseOrder />}></Route>
          <Route path='/purchase-order/view/:id' element={<PurchaseOrderView />}></Route>
          <Route path='/order/:id' element={<Transaction />}></Route>
          <Route path='/confirmation-message/:id' element={<ConfirmationMessage />}></Route>
          <Route path='/invoice/:id' element={<Invoice />}></Route>
          <Route path='/packing/:id' element={<Packing_Inspections />}></Route>
          <Route path='/delivery/:id' element={<Delivery />}></Route>
          <Route path='/stock/:id' element={<Stock_Reconciliation />}></Route>
          <Route path='/payment/:id' element={<Payment_Reconciliation />}></Route>
          <Route path='/retail-view/:id' element={<Retail />}></Route>
          <Route path='/retail/:id' element={<RetailView />}></Route>
          <Route path='/retail/info/:id' element={<RetailInfo />}></Route>
          <Route path='/packing-details/:id' element={<TransactionPacking />}></Route>
          <Route path='/delivery-details/:id' element={<TransactionDelivery />}></Route>
          <Route path='/stock-details/:id' element={<TransactionStock />}></Route>
          <Route path='/delete-me' element={<DeleteAccount />}></Route>
          <Route path='/order-form/:id' element={<OrderFormListPage />}></Route>
          <Route path='/:id/success-order' element={<SuccessOrder />}></Route>
          <Route path='/:id/order-history' element={<OrderHistory />}></Route>
          <Route path='/customer-chat/:id' element={<CustomerChatPage />}></Route>
          <Route path='/customer-chat/:id/order-discussion/:txnId' element={<CustomerChatPage />}></Route>
        </Routes>
      </BrowserRouter>
      {location !== "/customer-chat" && <footer style={{ backgroundColor: "#274472", color: "white", paddingBottom: 0 }} className='footer mt-auto  text-white footer-height mt-2' >
        <div className='container'>
          <div className="row mt-2">
            <div className="col-12 text-center">
              <div className='mb-0 fs-12'>Vyapar Live – All-in-One Business Growth Platform Increase</div>
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-4'></div>
            <div className='col-md-4'>
              <div className="fs-12 ms-1 pb-1 d-flex justify-content-around">
                <li>Sell More</li>
                <li>Work Smarter</li>
                <li>Stay Connected</li>
              </div>
            </div>
            <div className='col-md-4'></div>
            <div className='col-md-4'></div>
            <div className='col-md-4'>
              <div className='row align-items'>
                <div className='col-6 text-end'>
                  <div className="google-play-store">
                    <a href="https://play.google.com/store/apps/details?id=com.mrsoft.vyaparlive&hl=en" target='_blank'>
                      <img src={PLAYSTORE_ICON} alt="" className='responsive-width' />
                    </a>
                  </div>
                </div>
                <div className='col-6 text-center'>
                  <div className="text-start">
                    <a href="https://apps.apple.com/app/com.mrsoft.vyaparlive" target='_blank'>
                      <img src={APPSTORE_ICON} alt="" className='responsive-width' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-4'></div>
          </div>
          <p className='mb-1 fs-8 mt-1 text-center'>©{currentYear} <a href="https://www.vyaparlive.com/" style={{ color: 'yellow', textDecoration: 'none' }}>Vyaparlive</a>. All Rights Reserved</p>
          {/* <div className='row align-items my-2'>
            <div className='col-6 col-sm-6 col-md-6 col-lg-5 text-end'> <p className='mb-1 fs-14'>©{currentYear} <a href="https://www.vyaparlive.com/" style={{ color: 'yellow', textDecoration: 'none' }}>Vyaparlive</a>. All Rights Reserved</p></div>
            <div className='col-6'>
              <div className='row'>
                <div className="col-md-6 google-play-store">
                  <a href="https://play.google.com/store/apps/details?id=com.mrsoft.vyaparlive&hl=en" target='_blank'>
                    <img src={PLAYSTORE_ICON} alt="" className='responsive-width mb-1' />
                  </a>
                </div>
                <div className="col-md-6 text-start">
                  <a href="https://apps.apple.com/app/com.mrsoft.vyaparlive" target='_blank'>
                    <img src={APPSTORE_ICON} alt="" className='responsive-width' />
                  </a>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="row">
          <div className="col-6 text-center my-4 text-lg-end">
            <a href="https://play.google.com/store/apps/details?id=com.mrsoft.vyaparlive&hl=en" target='_blank'>
              <img src={PLAYSTORE_ICON} alt="" className='responsive-width' />
            </a>
          </div>
          <div className="col-6 text-center my-4 text-lg-start">
            <a href="https://apps.apple.com/app/com.mrsoft.vyaparlive" target='_blank'>
              <img src={APPSTORE_ICON} alt="" className='responsive-width' />
            </a>
          </div>
        </div> */}
          {/* <div className="text-center">
          <p className='mb-1 fs-14'>©{currentYear} <a href="https://www.vyaparlive.com/" style={{ color: 'yellow', textDecoration: 'none' }}>Vyaparlive</a>. All Rights Reserved</p>
        </div> */}
        </div>
      </footer>}
    </div >
  );
}

export default App;
